var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none",
    viewBox: "0 0 12 13",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.5 2.628 3.142 3.22a.5.5 0 0 0 .716-.698L6.5 1.197a.7.7 0 0 0-1.002 0L1.642 5.152a.5.5 0 0 0 .716.699L5.5 2.629v9.87a.5.5 0 0 0 1 0z",
    clipRule: "evenodd"
  })));
});
const SvgArrowUpsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUpsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjUgMi42MjgzNEw5LjY0MjEzIDUuODQ4NzFDOS44MzQ5NyA2LjA0NjM2IDEwLjE1MTUgNi4wNTAyNSAxMC4zNDkyIDUuODU3NDFDMTAuNTQ2OCA1LjY2NDU2IDEwLjU1MDcgNS4zNDggMTAuMzU3OSA1LjE1MDM1TDYuNTAxMDQgMS4xOTc0OEM2LjIyNjMzIDAuOTE1OTIyIDUuNzczNjIgMC45MTU5NDggNS40OTg5NCAxLjE5NzU0TDEuNjQyMDggNS4xNTEzN0MxLjQ0OTI2IDUuMzQ5MDUgMS40NTMxOSA1LjY2NTYgMS42NTA4NiA1Ljg1ODQzQzEuODQ4NTQgNi4wNTEyNSAyLjE2NTA5IDYuMDQ3MzIgMi4zNTc5MiA1Ljg0OTY1TDUuNSAyLjYyODU1VjEyLjQ5OTZDNS41IDEyLjc3NTcgNS43MjM4NiAxMi45OTk2IDYgMTIuOTk5NkM2LjI3NjE0IDEyLjk5OTYgNi41IDEyLjc3NTcgNi41IDEyLjQ5OTZWMi42MjgzNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";